
































































































































































































































































































import { NewAccountInterface, ValidationPassInterface } from "@/types.d.ts";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import CheckBox from "@/components/basic/fields/CheckBox.vue";
import Field from "@/components/basic/fields/Field.vue";
import Popup from "@/components/basic/Popup.vue";
import RodoInformation from "@/components/RodoInformation.vue";
import Vue from "vue";
import FillableBullet from "@/components/basic/fields/FillableBullet.vue";
import { ResponseError } from "@/types";
import { SET_PROGRESS, SET_DARK_BACKGROUND } from "@/constants/mutation-types";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import RecaptchaButton from "@/components/basic/buttons/RecaptchaSubmitButton.vue";
import { Locale } from "@/constants/locale";
import Radio from "@/components/basic/fields/Radio.vue";
import TheCountrySelect from "@/components/basic/fields/TheCountrySelect.vue";
import i18n from "@/i18n";
import { LanguageCodeByBranchCode } from "@/helpers/i18n";
import { UrlHelper } from "@/helpers/UrlHelper";
import { CountryHelper } from "@/helpers/CountryHelper";
import UkraineResidenceInfo from "@/components/UkraineResidenceInfo.vue";
import UkraineResidencePopup from "@/components/UkraineResidencePopup.vue";
import { TranslateResult } from "vue-i18n";
import { mapState } from "vuex";
import Cookies from "@/components/basic/Cookies.vue";

export default Vue.extend({
  name: "newAccount",
  computed: {
    UtilityHelper() {
      return UtilityHelper;
    },
    countries() {
      let countries = JSON.parse(JSON.stringify(this.$store.state.config.countries));
      const index = countries.findIndex((num: { key: string }) => num.key === i18n.locale.toUpperCase());
      countries.splice(index, 1);
      return countries;
    },
    getChooseLanguageTextByResidence(): TranslateResult {
      let citizenshipCode = this.formData.residenceCountry;
      citizenshipCode = citizenshipCode[0] + "" + citizenshipCode.slice(1);
      let t = "steps.NewAccount.chooseLanguageText" + citizenshipCode;
      return this.$t(t) != t ? this.$t(t) : this.$t("steps.NewAccount.chooseLanguageTextEN");
    },
    ...mapState({
      isLocked: (state: any) => state.isLocked,
      isDetectedMobileDevice: (state: any) => state.isDetectedMobileDevice,
    }),
  },
  data() {
    return {
      Locale,
      isErrors: null as null | Map<string, ResponseError>,
      isOpenOverlay: true,
      isConfirmResidence: false,
      isResidenceConfirmRadioRequired: false,
      isSelectResidenceRequired: false,
      isChooselanguageRequired: false,
      isRodoInformationOpen: false,
      isUkraineResidenceInfoOpen: false,
      isEmailValid: false,
      emailsMatch: false,
      showUaPopup: false,
      euAddress: null as null | boolean,
      passwordInputType: "password",
      isEmailConfirmed: false,
      playVideo: false,
      isMobile: false,
      videoDesktopUrl: "https://proxy.tms.pl/images/Oanda_NoTiles_EN.mp4",
      videoMobileUrl: "https://proxy.tms.pl/images/Oanda_Tiles_EN.mp4",
      posterDesktop: '@/assets/posters/OANDA/OANDA_Onboarding_HeaderAnim_NoTiles_EN.png',
      posterMobile: '@/assets/posters/OANDA/OANDA_Onboarding_HeaderAnim_NoTiles_EN.png',
      isSamsung: false,
      formData: {
        residenceConfirm: null as null | boolean,
        residenceCountry: "",
        chooseLanguage: null as null | boolean,
        email: "",
        confirmEmail: "",
        password: "",
        marketingAgreement: false,
        recaptchaToken: "",
      } as NewAccountInterface,
      validationPass: {
        flag: 0 as number,
        isValidPassword: false,
        isMixedLetters: false,
        isContainsNumber: false,
        isContainsEightChars: false,
        isContainsSpecialCharacter: false,
        passwordStrength: "",
        passwordProgress: 0,
      } as ValidationPassInterface | any,
      TRANSLATION_KEY: "steps.NewAccount",
    };
  },
  mounted() {
    this.$store.state.ajaxService.restart();
    this.$store.commit(SET_PROGRESS, 8);
    localStorage.setItem("reloaded", "false");
    this.isResidenceConfirmRadioRequired = UtilityHelper.getLocale() !== Locale.EN;
    this.isSelectResidenceRequired = !this.isResidenceConfirmRadioRequired;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const country = urlParams.get("lang");
    if (country && LanguageCodeByBranchCode.hasOwnProperty(country)) {
      (this.formData as any).residenceCountry = country.toUpperCase();
      (this.formData as any).residenceConfirm = false;
      this.isOpenOverlay = false;
      this.isConfirmResidence = true;
    }
    if (this.isResidenceConfirmRadioRequired && UtilityHelper.getLocale() !== Locale.UA) {
      this.formData.residenceConfirm = true;
    }
    this.writeUrlParams();
    this.replaceVideoUrl();
    const videoInterval = setInterval(() => {
      if (!this.isLocked) {
        clearInterval(videoInterval);
        setTimeout(() => {
          //@ts-ignore
          this.$refs.video.play();
        }, 200);
      }
    }, 100);
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    this.checkIsSamsung()
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize);
    }
  },
  methods: {
    checkIsSamsung(): void {
      if (window.navigator.userAgent.includes('SamsungBrowser') || window.navigator.userAgent.includes('SAMSUNG')) {
        this.isSamsung = true
      }
    },
    handleModal(): void {
      this.isRodoInformationOpen = !this.isRodoInformationOpen;
      this.$store.commit(SET_DARK_BACKGROUND, this.isRodoInformationOpen);
    },
    validatePassword(): void {
      // destructuring objs
      const { password } = this.formData;
      const {
        isMixedLetters,
        isContainsNumber,
        isContainsEightChars,
        isContainsSpecialCharacter,
      } = this.validationPass;

      // regExps array
      const regExp: RegExp[] = [
        /([a-z].*[A-Z])|([A-Z].*[a-z])/,
        /[0-9]/,
        /.{8,}/,
        /[-@#!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/,
      ];

      // for lower case and upper case letters
      if (regExp[0].test(password)) {
        if (!isMixedLetters) {
          this.makePasswordProgress("+", "isMixedLetters");
        }
      } else {
        if (isMixedLetters) {
          this.makePasswordProgress("-", "isMixedLetters");
        }
      }

      // for numbers
      if (regExp[1].test(password)) {
        if (!isContainsNumber) {
          this.makePasswordProgress("+", "isContainsNumber");
        }
      } else {
        if (isContainsNumber) {
          this.makePasswordProgress("-", "isContainsNumber");
        }
      }

      // for minimum eight chars length
      if (regExp[2].test(password)) {
        if (!isContainsEightChars) {
          this.makePasswordProgress("+", "isContainsEightChars");
        }
      } else {
        if (isContainsEightChars) {
          this.makePasswordProgress("-", "isContainsEightChars");
        }
      }

      // for special characters
      if (regExp[3].test(password)) {
        if (!isContainsSpecialCharacter) {
          this.makePasswordProgress("+", "isContainsSpecialCharacter");
        }
      } else {
        if (isContainsSpecialCharacter) {
          this.makePasswordProgress("-", "isContainsSpecialCharacter");
        }
      }

      this.checkIsValidPass();
      this.showPasswordProgress();
    },
    showPasswordProgress() {
      const { flag } = this.validationPass;

      if (flag === 1) {
        this.validationPass.passwordStrength = "#af251b";
      }
      if (flag === 2 || flag === 3) {
        this.validationPass.passwordStrength = "#f7b71d";
      }
      if (flag === 4) {
        this.validationPass.passwordStrength = "#339d36";
      }
    },
    makePasswordProgress(operation: string, regExpName: string) {
      if (operation === "+") {
        this.validationPass.flag += 1;
        this.validationPass[regExpName] = true;
        this.validationPass.passwordProgress += 25;
      } else {
        this.validationPass.flag -= 1;
        this.validationPass[regExpName] = false;
        this.validationPass.passwordProgress -= 25;
      }
    },
    checkIsValidPass() {
      const {
        isMixedLetters,
        isContainsNumber,
        isContainsEightChars,
        isContainsSpecialCharacter,
      } = this.validationPass;
      this.validationPass.isValidPassword = !!(
        isContainsEightChars &&
        isContainsNumber &&
        isMixedLetters &&
        isContainsSpecialCharacter
      );
    },
    handleOverlay() {
      this.isOpenOverlay = false;
      this.$store.state.analyticsService.sendStepEvent("residenceConfirm");
    },
    validateEmail() {
      const { email } = this.formData;
      const regExp: RegExp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      this.isEmailValid = regExp.test(email);
      this.emailsMatch = this.formData.email === this.formData.confirmEmail;
    },
    handleResidenceConfirm() {
      if (this.formData.residenceConfirm) {
        this.formData.residenceCountry = i18n.locale.toUpperCase();
        this.residenceReview();
        if (this.formData.residenceCountry !== "UA") {
          this.isOpenOverlay = false;
        }
      } else {
        if (LanguageCodeByBranchCode.hasOwnProperty(this.formData.residenceCountry.toLowerCase())) {
          if (this.formData.residenceCountry === "UA") {
            this.handleUkraineResidenceInfoOpen();
          } else {
            this.isChooselanguageRequired = true;
            this.isOpenOverlay = false;
          }
        } else if (!CountryHelper.isEuropeanCountry(this.formData.residenceCountry)) {
          const url = UrlHelper.getRedirectUrlByResidence(this.formData.residenceCountry);
          window.location.replace(url);
        } else {
          this.isOpenOverlay = false;
          this.isConfirmResidence = true;
        }
      }

      this.$store.state.analyticsService.analyticsData.residency = this.formData.residenceCountry;
      this.$store.state.analyticsService.sendStepEvent("newRegistration");
      window.scrollTo(0, 0);
    },
    handleChooseLanguage() {
      if (!this.formData.chooseLanguage) {
        this.isOpenOverlay = false;
        this.isChooselanguageRequired = false;
      }
      this.$store.state.analyticsService.sendStepEvent("chooseLanguage");
      window.scrollTo(0, 0);
    },
    handleUkraineResidenceInfoOpen() {
      this.showUaPopup = !this.showUaPopup;
    },
    residenceReview() {
      if (this.formData.residenceCountry === "UA") {
        this.handleUkraineResidenceInfoOpen();
      } else {
        this.isConfirmResidence = true;
      }
    },
    yesEuAddress() {
      this.showUaPopup = false;
      this.euAddress = true;
      this.isSelectResidenceRequired = true;
      this.formData.residenceConfirm = false;
    },
    showPassword(action: Boolean) {
      if (action) {
        this.passwordInputType = "text";
      } else {
        this.passwordInputType = "password";
      }
    },
    clearInput() {
      this.formData.email = "";
    },

    confirmEmail() {
      this.isEmailConfirmed = true;
      ((this.$refs.confirmEmail as any) as HTMLElement).classList.add("email-confirmed");
    },

    writeUrlParams() {
      const urlParams = window.location.search;
      if (urlParams && urlParams !== "?from=HP_UP") {
        this.$store.state.AdjustUrlParams = urlParams;
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 768;
    },

    replaceVideoUrl() {
      const locale = UtilityHelper.getLocale().toUpperCase();
      const version = UtilityHelper.isOandaPath() ? "OANDA" : "OTMS";
      this.videoDesktopUrl = `https://proxy.tms.pl/videos/${version}/${version}_Onboarding_HeaderAnim_NoTiles_${locale}.mp4`;
      this.videoMobileUrl = `https://proxy.tms.pl/videos/${version}/${version}_Onboarding_HeaderAnim_${locale}.mp4`;
      this.posterDesktop = `@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_NoTiles_${locale}.png`;
      this.posterMobile = `@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_${locale}.png`;
    },

    getMobilePoster() {
      const locale = UtilityHelper.getLocale().toUpperCase();
      const version = UtilityHelper.isOandaPath() ? "OANDA" : "OTMS";
      return require(`@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_${locale}.png`)
    },
  },
  watch: {
    "formData.residenceConfirm"() {
      if (this.isResidenceConfirmRadioRequired && !this.formData.residenceConfirm) {
        this.isSelectResidenceRequired = true;
      } else {
        this.isSelectResidenceRequired = false;
      }
    },
    "formData.email"() {
      this.formData.confirmEmail = this.formData.email;
      this.isEmailConfirmed = false;
      ((this.$refs.confirmEmail as any) as HTMLElement).classList.remove("email-confirmed")
    },
    "formData.residenceCountry"() {
      const localesArray = String(Object.values(this.Locale));
      if (localesArray.includes(this.formData.residenceCountry.toLowerCase())) {
        this.formData.chooseLanguage = true;
      }
      this.$store.state.residenceCountry = this.formData.residenceCountry;
    },
    "formData.chooseLanguage"(newValue) {
      if (newValue) {
        const redirectUrl = UrlHelper.getRedirectUrlByResidence(this.formData.residenceCountry);
        const redirectLink = document.querySelector(".redirect-link");
        if (redirectLink) {
          redirectLink.setAttribute("href", redirectUrl);
        }
      }
    },
    isMobile() {
      //@ts-ignore
      this.$refs.video.src = "";
      this.$nextTick(() => {
        //@ts-ignore
        this.$refs.video.src = this.isMobile ? this.videoMobileUrl : this.videoDesktopUrl;
        //@ts-ignore
        this.$refs.video.play();
      });
    },
  },
  components: {
    UkraineResidenceInfo,
    TheCountrySelect,
    Radio,
    RecaptchaButton,
    CheckBox,
    Field,
    SubmitButton,
    Popup,
    RodoInformation,
    FillableBullet,
    UkraineResidencePopup,
    Cookies,
  },
});
